import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";
import { ITextJoinBehavior } from "../../../../documaker/domain/format/objects";

export interface ITextJoinBehaviorPropertyEditable {
  textJoinBehavior(): IPropertyEditable<ITextJoinBehavior>;
}

export function instanceOfITextJoinBehaviorPropertyEditable(instance: any): instance is ITextJoinBehaviorPropertyEditable {
  return instance
      && instance.textJoinBehavior
      && instanceOfIPropertyEditable<ITextJoinBehavior>(instance.textJoinBehavior());
}
